import React from "react";
import { useFx } from "@/lib/fx";
import CurrencyPicker from "@/components/CurrencyPicker";

/**
 * "View all in {code}" toggle. Place near a page header.
 * Compact + functional — uses the global FxProvider.
 */
export default function ViewInCurrency({ testid = "view-in-currency" }) {
    const { base, setBase, loading, error } = useFx();
    return (
        <div className="flex items-center gap-2" data-testid={testid}>
            <span className="overline whitespace-nowrap">View all in</span>
            <div className="w-44">
                <CurrencyPicker value={base} onChange={setBase} testid={`${testid}-picker`} />
            </div>
            {loading && <span className="font-mono text-[10px] text-slate-400">fx…</span>}
            {error && !loading && (
                <span className="font-mono text-[10px] text-amber-700" title={error}>
                    fx offline
                </span>
            )}
        </div>
    );
}
